import React from "react";

import Slider from "react-slick";

import "./cardmitra.css";

export default function CardMitra() {
  const settings = {
    dots: true,
    infinite: true,
    slidesToShow: 5,
    slidesToScroll: 5,
    autoplay: true,
    speed: 8000,
    // autoplaySpeed: 2000,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 834,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
    ],
  };

  return (
    <>
      <div>
        <Slider {...settings}>
          <div className="item">
            <img
              src={require("../../assets/djarum.png")}
              alt="imageCardMitra"
              width={110}
            />
          </div>
          <div className="item">
            <img
              src={require("../../assets/sparkle.png")}
              alt="imageCardMitra"
              width={100}
            />
          </div>
          <div className="item">
            <img
              src={require("../../assets/nojorono.png")}
              alt="imageCardMitra"
              width={110}
            />
          </div>
          <div className="item">
            <img
              src={require("../../assets/panin.png")}
              alt="imageCardMitra"
              width={130}
            />
          </div>
          <div className="item">
            <img
              src={require("../../assets/manuva.png")}
              alt="imageCardMitra"
              width={110}
            />
          </div>
          <div className="item">
            <img
              src={require("../../assets/aroma.png")}
              alt="imageCardMitra"
              width={120}
            />
          </div>
          <div className="item">
            <img
              src={require("../../assets/gocement.png")}
              alt="imageCardMitra"
              width={110}
            />
          </div>
          <div className="item">
            <img
              src={require("../../assets/kritamedia.png")}
              alt="imageCardMitra"
              width={130}
            />
          </div>
          <div className="item">
            <img
              src={require("../../assets/jasindo.png")}
              alt="imageCardMitra"
              width={130}
            />
          </div>
          <div className="item">
            <img
              src={require("../../assets/blibli.png")}
              alt="imageCardMitra"
              width={110}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/jti.png")}
              className="img-fluid"
              alt="..."
              width={110}
            />
          </div>
          <div className="itemPortofolio">
            <img
              src={require("../../assets/link.png")}
              className="img-fluid"
              alt="..."
              width={110}
            />
          </div>
        </Slider>
      </div>
    </>
  );
}
